import { Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";

const bookExportDeliveryDataPush = (vehicle: Vehicle) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "request-export",
        action: "start",
        section: "pop-up",
        type: "",
        value: "",
      },
      ...vehicleDataPush,
    });
  }
};

export default bookExportDeliveryDataPush;
